import { TLShapeId } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { FrameShape } from './Types'
import { deleteFrame, getByPosition, getOrderedFrames } from './helpers'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { Trash4 } from 'blaze-ui/icons'
import { DeleteConfirmModal } from './DeleteConfirmModal'
import { useConfirmModal } from 'hooks/useConfirmModal'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

interface Props {
  id: TLShapeId
  supportsCaption?: boolean
}

export const Delete = ({ id, supportsCaption = false }: Props) => {
  const editor = useEditor()
  const shape = editor.getShape<FrameShape>(id)
  const deleteConfirm = useConfirmModal(DeleteConfirmModal)

  if (!shape) return null

  const handlePress = async () => {
    const confirm = await deleteConfirm()

    if (!confirm) {
      return
    }

    const orderedFrames = getOrderedFrames(editor)
    const reorderedFrames = deleteFrame(orderedFrames, shape.props.position, supportsCaption)
    editor.updateShapes(reorderedFrames)
    editor.deleteShape(id)
    let firstFrame = getByPosition(editor, 1)

    if (!firstFrame) {
      return
    }

    const firstFrameBounds = editor.getShapePageBounds(firstFrame)

    if (!firstFrameBounds) {
      return
    }

    editor.zoomToBounds(firstFrameBounds, undefined, { duration: 500, easing: (t) => t * (2 - t) })
    showToastMessage('Page successfully deleted')
  }

  return (
    <Tooltip label="Delete" placement="left">
      <IconButton
        variant="ghost"
        size="sm"
        icon={() => <Trash4 size={20} />}
        aria-label="Delete"
        onPress={handlePress}
      />
    </Tooltip>
  )
}
